class SupportFinder extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.supportButtons = [...this.querySelectorAll('[data-support-option]')];
    this.feelButtons = [...this.querySelectorAll('[data-feel-option]')];
    this.feelStep = this.querySelector('[data-feel-step]');
    this.fixedNote = this.querySelector('[data-fixed-note]');
    this.resultsLink = this.querySelector('[data-results-link]');
    this.status = this.querySelector('[data-support-status]');
    this.supportButtons.forEach((button) => button.addEventListener('click', () => this.selectSupport(button)));
    this.feelButtons.forEach((button) => button.addEventListener('click', () => this.selectFeel(button)));
  }

  selectSupport(button) {
    this.supportButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    this.feelButtons.forEach((item) => item.setAttribute('aria-pressed', 'false'));
    this.selectedSupport = button;
    this.selectedFeel = null;
    const fixed = button.dataset.fixedFeel === 'true';
    this.feelStep.disabled = fixed;
    this.feelStep.dataset.fixed = String(fixed);
    this.fixedNote.hidden = !fixed;
    if (fixed) this.setResult(button.dataset.fixedUrl);
    else this.setResult('');
    this.status.textContent = `${button.textContent.trim()} selected.${fixed ? ' View recommended beds is available.' : ' Now choose your preferred feel.'}`;
  }

  selectFeel(button) {
    if (!this.selectedSupport) return;
    this.feelButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    this.selectedFeel = button.dataset.feel;
    this.setResult(this.selectedSupport.dataset[`${this.selectedFeel}Url`]);
    this.status.textContent = `${button.textContent.trim()} feel selected. View recommended beds is available.`;
  }

  setResult(url) {
    if (url) {
      this.resultsLink.href = url;
      this.resultsLink.removeAttribute('aria-disabled');
    } else {
      this.resultsLink.removeAttribute('href');
      this.resultsLink.setAttribute('aria-disabled', 'true');
    }
  }
}

if (!customElements.get('support-finder')) customElements.define('support-finder', SupportFinder);
